/**
 * AuthLayout — Wrapper for auth pages (Login, Register, ForgotPassword, ResetPassword)
 * Redirects authenticated users; otherwise renders child page full-width.
 * Each auth page handles its own visual design (hero banners, cards, etc.)
 */
import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';

const AuthLayout = () => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    const roleRedirects = {
      vendor: '/vendor',
      admin: '/admin',
      super_admin: '/admin',
      venue_owner: '/venue',
      coordinator: '/coordinator'
    };
    const dest = roleRedirects[user?.role] || '/dashboard';
    return <Navigate to={dest} replace />;
  }

  return <Outlet />;
};

export default AuthLayout;
